<template>
    <nav class="navbar is-mobile" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <RouterLink class="navbar-item" to="/">
                <img v-once class="logo" src="@/assets/logo.png">
                <span class="has-text-weight-bold">OCA</span>
            </RouterLink>
            <a class="navbar-burger has-text-light" role="button" aria-label="menu" aria-expanded="false"
                @click="toggleMenu">
                <font-awesome-icon :icon="['fas', (isMenuActive ? 'x' : 'bars')]" />
            </a>
        </div>

        <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
            <div class="navbar-start">
                <RouterLink class="navbar-item" to="/">
                    Legs
                </RouterLink>
                <RouterLink class="navbar-item" to="/checkrides">
                    Checkrides
                </RouterLink>
                <RouterLink v-if="isAdmin" class="navbar-item" to="/settings">
                    Settings
                </RouterLink>
                <a class="navbar-item is-hidden-tablet" @click="logout">
                    Logout
                </a>
            </div>
        </div>

        <div class="navbar-end">
            <div class="navbar-item is-hidden-touch">
                <span class="mr-2">{{ userEmail }}</span>
                <div class="buttons">
                    <a class="button" @click="logout">
                        <span>Logout</span>
                        <span class="icon">
                            <font-awesome-icon :icon="['fas', 'right-from-bracket']" />
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store'

export default {
    setup() {
        const isMenuActive = ref(false)
        const router = useRouter()
        const authStore = useAuthStore()

        const toggleMenu = () => {
            isMenuActive.value = !isMenuActive.value
        }

        const logout = async () => {
            try {
                await authStore.logout()
                router.push('/login')
            } catch (error) {
                console.error('Logout failed:', error)
            }
        }

        const userEmail = computed(() => authStore.user?.email || '')
        const isAdmin = computed(() => authStore.user?.labels?.includes('admin') || false)

        return {
            isMenuActive,
            toggleMenu,
            logout,
            userEmail,
            isAdmin
        }
    }
}
</script>

<style>
.logo {
    height: var(--bulma-navbar-item-img-max-height);
}

.navbar {
    border-bottom: rgba(255, 255, 255, 0) 1px solid;
}
</style>